import React, { useState, useEffect } from "react";
import axios from 'axios';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import useFormContext from "./useFormMarsComplete.js"
import ReactQuill from 'react-quill';
import { DOWNLOAD_ATTACHMENTS_URL, DOWNLOAD_BRIEF_URL } from "../ApiDetails.js";

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" style={infoIconStyle}>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
    <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="8" r="1" fill="currentColor" />
  </svg>
);

const infoIconStyle = {
  color: 'darkblue',
  marginRight: '10px',
  fontSize: '16px',
  cursor: 'pointer'
};

const ScheduleMarsComplete = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    eventFormData, comments, setComments,
    addCommentsDraftSection, addCommentsVisitSection,
    addCommentsBriefSection, addCommentsAttachmentSection, editable, attachments, briefs
  } = useFormContext()

  const handleInfoClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false); // Closes the modal
  };

  const fileDownload = require('js-file-download');
  const downloadAttachment = (attachment) => {
    axios.get(`${DOWNLOAD_ATTACHMENTS_URL}/${encodeURIComponent(attachment)}`, { responseType: 'blob' })
      .then(response => {
        fileDownload(response.data, attachment);
      })
      .catch(error => {
        console.error('Error updating the details: ', error);
      });
  }

  const downloadBrief = (brief) => {
    axios.get(`${DOWNLOAD_BRIEF_URL}/${encodeURIComponent(brief)}`, { responseType: 'blob' })
      .then(response => {
        fileDownload(response.data, brief);
      })
      .catch(error => {
        console.error('Error updating the details: ', error);
      });
  }

  useEffect(() => {
    if (editable) {
      var elementArray = document.getElementsByClassName("editable");
      if (elementArray && elementArray.length > 0) {
        for (var i = 0; i < elementArray.length; i++) {
          elementArray[i].removeAttribute("hidden");
        }
      }
    }
    else {
      var elementArray1 = document.getElementsByClassName("editable");
      if (elementArray1 && elementArray1.length > 0) {
        for (var j = 0; j < elementArray1.length; j++) {
          elementArray1[j].setAttribute("hidden", true);
        }
      }
    }
    var editor = document.getElementsByClassName("ql-toolbar")
    if (editor != null) {
      for (var k = 0, len = editor.length; k < len; ++k) {
        editor[k].hidden = true;
      }
    }
  }, []);

  const defaultStyles = `
  .ql-editor {
    font-family: 'Mars Centra';
  }
`;

  const content = (
    <>
      <style>{defaultStyles}</style>
      <div className="col-md-10">
        <div className=" bg-light rounded my-4 p-4 mt-3 visit-summary" id="visitContentTitleDiv">
          <div className="visit-title" style={{ marginBottom: '10px' }}>Visit Summary</div>
          <ReactQuill
            style={{ border: '1px solid #ced4da', marginBottom: '20px' }}
            value={eventFormData.schedule.visitSummary}
            name="visitSummary"
            readOnly={true} />
        </div>
        <div className="form-group row mb-2 align-items-center editable" id="visitContentTitlebutton" >
          <div className="col-sm-9 pr-0" >
            <input
              type="text"
              readOnly=""
              className="custom-font-lt form-control"
              value={comments.VisitSection}
              placeholder={!editable ? "" : "Leave a comment"}
              onChange={(e) => { setComments({ ...comments, "VisitSection": e.target.value }) }}

            />
          </div>
          <div className="col-sm-3 pl-0" >
            <button type="button" className="buttonrequest btn btn-success ml-2"
              onClick={(e) => { e.preventDefault(); addCommentsVisitSection(); }}
            >
              SEND COMMENT
            </button>
          </div>
        </div>
        <div className=" bg-light my-4 p-4 rounded p-3 " id="itineraryContentTitleDiv">
          <div className="itinerary-title" style={{ marginBottom: '10px' }}>draft itinerary</div>
          <ReactQuill
            style={{ border: '1px solid #ced4da', marginBottom: '20px' }}
            value={eventFormData.schedule.draftItinerary}
            name="visitSummary"
            readOnly={true} />
        </div>
        <div className="form-group row mb-2 align-items-center editable" id="itineraryContentTitlebutton" >
          <div className="col-sm-9 pr-0">
            <input
              type="text"
              readOnly=""
              className="custom-font-lt form-control"
              value={comments.DraftSection}
              placeholder={!editable ? "" : "Leave a comment"}
              onChange={(e) => { setComments({ ...comments, "DraftSection": e.target.value }) }}
            />
          </div>
          <div className="col-sm-3 pl-0">
            <button type="button" className="buttonrequest btn btn-success ml-2"
              onClick={(e) => { e.preventDefault(); addCommentsDraftSection(); }}
            >
              SEND COMMENT
            </button>
          </div>
        </div>
        <div className="bg-light rounded p-4 mt-3">
          <label htmlFor="staticEmail" className="custom-font col-form-label">
            BRIEF - Optional at the request stage, required once event is accepted
            <div onClick={handleInfoClick} style={{ cursor: "pointer", position: "relative", display: "inline-block", marginLeft: "10px" }}>
              <InfoIcon />

            </div>
          </label>
          <Modal open={isModalOpen} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
                height: "80%",
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 2,
                overflow: "hidden",
              }}
            >
              <iframe
                src="/files/Site_Briefing_Template_for_engagement.pdf"
                style={{
                  width: "100%",
                  height: "90%",
                  border: "none",
                }}
                title="Document Viewer"
              ></iframe>
              <button
                onClick={handleClose}
                style={{
                  marginTop: "10px",
                  display: "block",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >Close</button>
            </Box>
          </Modal>
          <ul className="list-group" id="SchbriffList">
          </ul>
        </div>
        <div className=" bg-light rounded p-4 mt-3" id="SchBriefAdmin">
          <label htmlFor="staticEmail" className="custom-font col-form-label">
            BRIEF
          </label>
          <ul className="list-group" id="SchBriefAdmin">
            {briefs.map((brief, index) => (
              <li key={index} id={brief} className="list-group-item-custom list-group-item m-1 d-flex justify-content-between align-items-center">
                <u>
                  <a href="#" onClick={(e) => { e.preventDefault(); downloadBrief(brief); }}>{brief}</a>
                </u>
              </li>
            ))}
          </ul>
          <br />
          <div className="form-group row mb-2 align-items-center editable" id="briefButtonDiv" >
            <div className="col-sm-9 pr-0">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control"
                value={comments.BriefSection}
                placeholder={!editable ? "" : "Leave a comment"}
                onChange={(e) => { setComments({ ...comments, "BriefSection": e.target.value }) }}
              />
            </div>
            <div className="col-sm-3 pl-0">
              <button type="button" className="buttonrequest btn btn-success ml-2"
                onClick={(e) => { e.preventDefault(); addCommentsBriefSection(); }}
              >
                SEND COMMENT
              </button>
            </div>
          </div>

        </div>
        <div className="bg-light rounded p-4 mt-3 mb-5">
          <label htmlFor="staticEmail" className="custom-font col-form-label">
            ATTACHMENTS
          </label>
          <ul className="list-group" id="SchAttListAdmin">
            {attachments.map((attachment, index) => (
              <li key={index} id={attachment} className="list-group-item-custom list-group-item m-1 d-flex justify-content-between align-items-center">
                <u>
                  <a href="#" onClick={(e) => {e.preventDefault();downloadAttachment(attachment);}}>{attachment}</a>
                </u>
              </li>
            ))}
          </ul>
          <br />
          <div className="form-group row mb-2 align-items-center editable" id="attachCommentDiv" >
            <div className="col-sm-9 pr-0">
              <input
                type="text"
                className="custom-font-lt form-control"
                placeholder={!editable ? "" : "Leave a comment"}
                value={comments.AttachmentSection}
                onChange={(e) => { setComments({ ...comments, "AttachmentSection": e.target.value }) }}
              />
            </div>
            <div className="col-sm-3 pl-0">
              <button type="button" className="buttonrequest btn btn-success ml-2"
                onClick={(e) => { e.preventDefault(); addCommentsAttachmentSection(); }}>
                SEND COMMENT
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </>
  )
  return content;
}

export default ScheduleMarsComplete;